<mat-label *ngIf="labelKey">
  {{ labelKey | locLabel}} <app-required-indicator *ngIf="required"></app-required-indicator>
</mat-label>
<a *ngIf="reset" class="reset mat-caption" (click)="onReset.emit($event)">{{ 'button.default' | loc }}</a>
